import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop'
import produce from 'immer';
import { useRecoilState } from 'recoil';
import { quizState } from '@/models/quizState';
import { useEffect } from 'react';
import { QuizAlert } from '@/components/Alert';
import { ImageViewer } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import { DQuizQuestionComponent } from './DQuiz';
import { AnalysisComponent } from '../Mobile/MAnalysis';
import './DAnalysis.scss'
import BlankPage from '@/components/Error/blank';



export const DesktopAnalysis = () => {

    const navigate = useNavigate()

    const [quiz, setQuiz] = useRecoilState(quizState)

    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location]);


    if (quiz.questionList.length === 0) {
        return <BlankPage />
    }

    return (
        <LayoutDesktop>
            <div className='desktop-quiz-content'>
                <div className='desktop-quiz-top'>
                    <p className='desktop-analysis-top-title'></p>
                </div>
                {
                    quiz.questionList.map((item, index) => (
                        <DQuizQuestionComponent key={index} question={item} index={index} allowClick={false}>
                            <AnalysisComponent question={item} />
                        </DQuizQuestionComponent>
                    ))
                }
            </div>
            <div className='desktop-quiz-control'>
                <div className='desktop-quiz-control-back pointer' onClick={() => {
                    navigate(-1)
                }}></div>
            </div>
            <ImageViewer
                image={quiz.image}
                visible={quiz.visible}
                onClose={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.image = ''
                        draftState.visible = false
                    }))
                }}
            />
            {quiz.alert && <QuizAlert />}
        </LayoutDesktop>
    )

}


